 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"addcompany":"addcompany","addcontractor":"addcontractor","addcustomer":"addcustomer","addemployee~addinstallation~addmagazineitem~addpayment~addsquad~dashboard~eventlist~installation~mag~a8de447e":"addemployee~addinstallation~addmagazineitem~addpayment~addsquad~dashboard~eventlist~installation~mag~a8de447e","addemployee":"addemployee","addinstallation":"addinstallation","addmagazineitem":"addmagazineitem","addpayment":"addpayment","addsquad":"addsquad","dashboard~installation~services~warranty-service":"dashboard~installation~services~warranty-service","dashboard~services":"dashboard~services","dashboard":"dashboard","services":"services","installation":"installation","warranty-service":"warranty-service","eventlist":"eventlist","magazine":"magazine","payments~paymentsarchive~paymentscosts~paymentsdue":"payments~paymentsarchive~paymentscosts~paymentsdue","payments":"payments","paymentsarchive":"paymentsarchive","paymentscosts":"paymentscosts","paymentsdue":"paymentsdue","addmeeting":"addmeeting","cars":"cars","company":"company","contractors":"contractors","customer":"customer","login":"login","offers~offersarchive":"offers~offersarchive","offers":"offers","offersarchive":"offersarchive","squad":"squad","usersettings":"usersettings"}[chunkId]||chunkId) + "." + {"addcompany":"2a86f9a2","addcontractor":"756436cb","addcustomer":"7451d84e","addemployee~addinstallation~addmagazineitem~addpayment~addsquad~dashboard~eventlist~installation~mag~a8de447e":"de4a09bb","addemployee":"e68ed05e","addinstallation":"432082ef","addmagazineitem":"ca507172","addpayment":"9077c61d","addsquad":"809f420c","dashboard~installation~services~warranty-service":"55228e2d","dashboard~services":"cf397057","dashboard":"a6cc9654","services":"c9e9ad01","installation":"296cdd15","warranty-service":"730179b9","eventlist":"5bc3bb76","magazine":"6f7d7584","payments~paymentsarchive~paymentscosts~paymentsdue":"7249b1dd","payments":"04eb6ab6","paymentsarchive":"e987bac3","paymentscosts":"ce70d18e","paymentsdue":"d71b61a8","addmeeting":"fd84d0f6","cars":"51c61085","company":"ff11aebc","contractors":"da100db3","customer":"2b9b31d5","login":"2d6ac936","offers~offersarchive":"e8b87369","offers":"daffbc6e","offersarchive":"b78e6e1c","squad":"015c25b9","usersettings":"81478659","chunk-2d0aacc0":"f57c36b2","chunk-2d0ab514":"b5b61e73","chunk-2d0b1e5f":"84e6d4f4","chunk-2d0b21c6":"bdeddeee","chunk-2d0b326e":"773415d8","chunk-2d0b34b9":"ad5edf1a","chunk-2d0ba549":"e350c97e","chunk-2d0bceb4":"7bc1a4a8","chunk-2d0bddf4":"f0c24d00","chunk-2d0bdf49":"c46448c2","chunk-2d0c0ebf":"711ce51d","chunk-2d0c1979":"760699f8","chunk-2d0c1b75":"3970d5f3","chunk-2d0cf715":"ad4a5325","chunk-2d0d691f":"8000c067","chunk-2d0d836a":"a9b2deef","chunk-2d0da410":"5c455c16","chunk-2d0e1743":"bbb59034","chunk-2d0e19ee":"3725b34f","chunk-2d0e1c30":"5f70be04","chunk-2d0e8e41":"6cce68a8","chunk-2d0e9358":"e765e9bf","chunk-2d0f0fd0":"78539031","chunk-2d0f11af":"174a67dd","chunk-2d2091bd":"944c45ab","chunk-2d209206":"07f1646b","chunk-2d20e860":"4b2d86dc","chunk-2d20f169":"526c3f86","chunk-2d20f186":"88e955fc","chunk-2d21009e":"4bb32095","chunk-2d212bf1":"9d6e5e6f","chunk-2d21329e":"9a760872","chunk-2d21a426":"6dd2842d","chunk-2d21d4e1":"eab6b297","chunk-2d21e3f7":"7aaf4543","chunk-2d224d24":"8cdd75d2","chunk-2d22d9a8":"99505034","chunk-2d22d9ba":"d7e83914","chunk-2d22db83":"72c0c647","chunk-2d237752":"ea638496","chunk-146de506":"1bbc66f2","chunk-2d216214":"425d13cb"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"addcompany":1,"addcontractor":1,"addcustomer":1,"addinstallation":1,"addmagazineitem":1,"addpayment":1,"dashboard~installation~services~warranty-service":1,"dashboard~services":1,"dashboard":1,"services":1,"installation":1,"warranty-service":1,"eventlist":1,"magazine":1,"payments~paymentsarchive~paymentscosts~paymentsdue":1,"payments":1,"paymentsarchive":1,"paymentscosts":1,"paymentsdue":1,"addmeeting":1,"company":1,"contractors":1,"customer":1,"login":1,"offers":1,"offersarchive":1,"squad":1,"usersettings":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"addcompany":"addcompany","addcontractor":"addcontractor","addcustomer":"addcustomer","addemployee~addinstallation~addmagazineitem~addpayment~addsquad~dashboard~eventlist~installation~mag~a8de447e":"addemployee~addinstallation~addmagazineitem~addpayment~addsquad~dashboard~eventlist~installation~mag~a8de447e","addemployee":"addemployee","addinstallation":"addinstallation","addmagazineitem":"addmagazineitem","addpayment":"addpayment","addsquad":"addsquad","dashboard~installation~services~warranty-service":"dashboard~installation~services~warranty-service","dashboard~services":"dashboard~services","dashboard":"dashboard","services":"services","installation":"installation","warranty-service":"warranty-service","eventlist":"eventlist","magazine":"magazine","payments~paymentsarchive~paymentscosts~paymentsdue":"payments~paymentsarchive~paymentscosts~paymentsdue","payments":"payments","paymentsarchive":"paymentsarchive","paymentscosts":"paymentscosts","paymentsdue":"paymentsdue","addmeeting":"addmeeting","cars":"cars","company":"company","contractors":"contractors","customer":"customer","login":"login","offers~offersarchive":"offers~offersarchive","offers":"offers","offersarchive":"offersarchive","squad":"squad","usersettings":"usersettings"}[chunkId]||chunkId) + "." + {"addcompany":"b1368fd3","addcontractor":"2283fe17","addcustomer":"1fee8abe","addemployee~addinstallation~addmagazineitem~addpayment~addsquad~dashboard~eventlist~installation~mag~a8de447e":"31d6cfe0","addemployee":"31d6cfe0","addinstallation":"c34765ad","addmagazineitem":"7253251c","addpayment":"12daa139","addsquad":"31d6cfe0","dashboard~installation~services~warranty-service":"4b6bf062","dashboard~services":"93c83436","dashboard":"71b8d25f","services":"8678b1f9","installation":"6300a178","warranty-service":"7030e129","eventlist":"474f53a6","magazine":"72f8a103","payments~paymentsarchive~paymentscosts~paymentsdue":"8b06b080","payments":"427b60d9","paymentsarchive":"e8e03470","paymentscosts":"7a976742","paymentsdue":"6a664d4d","addmeeting":"b6eec8e6","cars":"31d6cfe0","company":"549591ca","contractors":"f5fef277","customer":"0e2b9eb5","login":"356ba5a9","offers~offersarchive":"31d6cfe0","offers":"43cc65dd","offersarchive":"e6dd51fa","squad":"63a89d0a","usersettings":"a7bf4b9e","chunk-2d0aacc0":"31d6cfe0","chunk-2d0ab514":"31d6cfe0","chunk-2d0b1e5f":"31d6cfe0","chunk-2d0b21c6":"31d6cfe0","chunk-2d0b326e":"31d6cfe0","chunk-2d0b34b9":"31d6cfe0","chunk-2d0ba549":"31d6cfe0","chunk-2d0bceb4":"31d6cfe0","chunk-2d0bddf4":"31d6cfe0","chunk-2d0bdf49":"31d6cfe0","chunk-2d0c0ebf":"31d6cfe0","chunk-2d0c1979":"31d6cfe0","chunk-2d0c1b75":"31d6cfe0","chunk-2d0cf715":"31d6cfe0","chunk-2d0d691f":"31d6cfe0","chunk-2d0d836a":"31d6cfe0","chunk-2d0da410":"31d6cfe0","chunk-2d0e1743":"31d6cfe0","chunk-2d0e19ee":"31d6cfe0","chunk-2d0e1c30":"31d6cfe0","chunk-2d0e8e41":"31d6cfe0","chunk-2d0e9358":"31d6cfe0","chunk-2d0f0fd0":"31d6cfe0","chunk-2d0f11af":"31d6cfe0","chunk-2d2091bd":"31d6cfe0","chunk-2d209206":"31d6cfe0","chunk-2d20e860":"31d6cfe0","chunk-2d20f169":"31d6cfe0","chunk-2d20f186":"31d6cfe0","chunk-2d21009e":"31d6cfe0","chunk-2d212bf1":"31d6cfe0","chunk-2d21329e":"31d6cfe0","chunk-2d21a426":"31d6cfe0","chunk-2d21d4e1":"31d6cfe0","chunk-2d21e3f7":"31d6cfe0","chunk-2d224d24":"31d6cfe0","chunk-2d22d9a8":"31d6cfe0","chunk-2d22d9ba":"31d6cfe0","chunk-2d22db83":"31d6cfe0","chunk-2d237752":"31d6cfe0","chunk-146de506":"31d6cfe0","chunk-2d216214":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
